module.exports = __webpack_public_path__ + "static/img/1023.cdbba19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1023.jpg
// module id = 205
// module chunks = 0